/**
 * Dependencies
 */
import {
    getFile,
    getWarRoom,
    deleteFile,
    deleteMultipleFiles
} from '../../../services/WarRoomService'

/**
 * Retrieve a war room by ID
 *
 * @param  {Number} id
 * @return {Promise}
 */
const getWarRoomById = ({commit}, id) => {
    commit('SET_PENDING')
    return getWarRoom(id)
        .then(res => {
            commit('GET_WAR_ROOM_SUCCESS', res.data)
            return Promise.resolve(res.data)
        })
        .catch(err => {
            commit('GET_WAR_ROOM_FAILURE', err)
            return Promise.reject(err)
        })
}

/**
 * Reset the state
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const resetState = ({ commit }) => {
    commit('RESET_STATE')
}

/**
 * [description]
 *
 * @param  {[type]} options.commit [description]
 * @return {[type]}                [description]
 */
const fileAddedToQueue = ({ commit }, payload) => {
    commit('QUEUE_FILE', payload)
}

/**
 * [description]
 *
 * @param  {[type]} options.commit [description]
 * @return {[type]}                [description]
 */
const uploadProgress = ({ commit }, payload) => {
    console.log('upload progress', payload)
}

/**
 * [description]
 *
 * @param  {[type]} options.commit [description]
 * @return {[type]}                [description]
 */
const fileCompleted = ({ commit }, payload) => {
    console.log('file completed', payload)
}

/**
 * [description]
 *
 * @param  {[type]} options.commit [description]
 * @return {[type]}                [description]
 */
const totalUploadProgress = ({ commit }, payload) => {
    console.log('total upload progress', payload)
}

/**
 * All done notification
 *
 * @param  {[type]} options.commit [description]
 * @return {[type]}                [description]
 */
const notifyAllCompleted = ({ commit }) => {
    console.log('all completed')
}

/**
 * Add a file to the wor room
 *
 * @param  {[type]} options.commit [description]
 * @return {[type]}                [description]
 */
const addFileToWarRoom = ({ commit }, file) => {
    commit('ADD_FILE', file)
}

/**
 * Remove a single file from a war room
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @param  {Number} fileId
 * @return {Promise}
 */
const deleteSingleFile = ({ commit, state, dispatch }, fileId) => {
    return deleteFile(state.data.id, fileId)
        .then(res => {
            commit('FILE_DELETED_SUCCESS', fileId)
            dispatch('addNotification', {
                title: 'File successfully deleted',
                type: 'success',
                text: 'The file was successfully removed from the war room.',
                timeout: true
            }, { root: true })
            return Promise.resolve(res.data)
        })
        .catch(err => {
            dispatch('addNotification', {
                title: 'File not deleted',
                type: 'error',
                text: 'There was a problem deleting your file. Please try again.',
                timeout: true
            }, { root: true })
            return Promise.resolve(err)
        })
}

/**
 * Select a file
 *
 * @param  {Function} options.commit
 * @param  {Number} file.id
 * @return {Void}
 */
const selectFile = ({ commit, state }, id) => {
    let idx = state.selected.indexOf(id)
    idx > -1
        ? commit('DESELECT_FILE', idx)
        : commit('SELECT_FILE', id)
}

/**
 * Select all files
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @return {Void}
 */
const selectAllFiles = ({ commit, state }, checked) => {
    checked
        ? commit('SELECT_ALL_FILES')
        : commit('DESELECT_ALL_FILES')
}

/**
 * Delete multiple files
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @return {Promise}
 */
const deleteSelectedFiles = ({ commit, state, dispatch }) => {
    return deleteMultipleFiles(state.data.id, state.selected.join(','))
        .then(() => {
            commit('REMOVE_MULTIPLE_FILES')
            commit('DESELECT_ALL_FILES')
            dispatch('addNotification', {
                title: 'Files Removed',
                type: 'success',
                text: 'The selected files were removed from the war room.',
                timeout: true
            }, { root: true })
            return Promise.resolve()
        })
        .catch(err => Promise.reject(err))
}

/**
 * Replace a war room file object
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
const replaceFileObject = ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
        commit('REPLACE_FILE', payload)
        resolve(payload)
    })
}

/**
 * Retrieve a file by ID
 *
 * @param  {Function} options.commit
 * @param  {Number} id
 * @return {Promise}
 */
const getFileById = ({ commit, state }, id) => {
    return getFile(state.data.id, id)
}

export default {
    selectFile,
    resetState,
    getFileById,
    fileCompleted,
    selectAllFiles,
    getWarRoomById,
    uploadProgress,
    addFileToWarRoom,
    deleteSingleFile,
    fileAddedToQueue,
    replaceFileObject,
    notifyAllCompleted,
    totalUploadProgress,
    deleteSelectedFiles
}



// WEBPACK FOOTER //
// ./src/state/modules/war-room/actions.js